import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import ContextPropertyInputPortList from "../components/ContextPropertyInputPortList";

const ContextPropertyModifierPanel = (props) => {
    return (
        <PanelLayout>
            <ContextPropertyInputPortList clickedNodeInfo={props.clickedNodeInfo}
                                          clickedNodeAction={props.clickedNodeAction}/>
        </PanelLayout>
    );
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(ContextPropertyModifierPanel);